import React, { useState } from "react";
import { Form, Input, Button, Checkbox, Card, Alert, Space } from "antd";
import { UserOutlined, LockOutlined, SettingOutlined } from "@ant-design/icons";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import EnvironmentConfigModal from "./EnvironmentConfigModal";

const LoginForm = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showEnvironmentModal, setShowEnvironmentModal] = useState(false);

  const onFinish = async (values) => {
    try {
      setError("");
      setLoading(true);

      await login(values.username, values.password);
      navigate("/"); // Redirigir al inicio después de iniciar sesión
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card title="Iniciar Sesión" style={{ maxWidth: 400, margin: "20px auto" }}>
        {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}

        <Form name="login" initialValues={{ remember: true }} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="username"
            // Es el No. del cajero en Business Central: loginUser busca por ese
            // campo, no por un nombre de usuario aparte.
            label="Usuario (No.)"
            rules={[{ required: true, message: "Por favor ingrese su usuario" }]}
          >
            <Input prefix={<UserOutlined />} placeholder="Usuario (No.)" />
          </Form.Item>

          <Form.Item
            name="password"
            label="Contraseña"
            rules={[{ required: true, message: "Por favor ingrese su contraseña" }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Contraseña" />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>Recordarme</Checkbox>
          </Form.Item>

          <Form.Item>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Button type="primary" htmlType="submit" loading={loading} block>
                Iniciar Sesión
              </Button>
              <Button
                type="default"
                icon={<SettingOutlined />}
                block
                onClick={() => setShowEnvironmentModal(true)}
                disabled={loading}
              >
                Configurar Entorno
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      <EnvironmentConfigModal
        visible={showEnvironmentModal}
        onClose={() => setShowEnvironmentModal(false)}
      />
    </>
  );
};

export default LoginForm;
